import { hideVisually, rem } from 'polished';
import ReactSlider from 'react-slider';
import styled from 'styled-components';

import { IUserType } from '../../';

export const StyledLabel = styled.span`
  display: flex;
  justify-content: center;
  margin-bottom: ${rem('16px')};
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('16px')};
  font-weight: 400;
  line-height: 1.4;
`;

export const StyledTrack = styled.div`
  top: ${rem('16px')};
  height: ${rem('1px')};
  border-radius: 100%;
`;

export const StyledThumb = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${rem('32px')};
  line-height: ${rem('32px')};
  width: ${rem('32px')};
  text-align: center;
  background-color: ${({ theme }) => theme.colors.main};
  border: 1px solid ${({ theme }) => theme.colors.cross.silverFox};
  border-radius: 100%;
  box-sizing: border-box;
  cursor: grab;

  &:focus {
    outline: none; //TODO add proper focus style
  }

  span {
    ${hideVisually()}
  }

  svg {
    height: auto;
    width: ${rem('8px')};
  }
`;

export const StyledSlider = styled(ReactSlider)`
  width: 100%;
  height: ${rem('32px')};
  touch-action: none;
`;

export const StyledValue = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('16px')};
  font-weight: 400;
  line-height: 1.4;
`;

export const StyledWrapper = styled.div<IUserType>`
  position: relative;

  ${StyledTrack} {
    &:nth-of-type(even) {
      background-color: ${({ theme, user }) => user && theme.colors[user].main};
    }

    &:nth-of-type(odd) {
      background-color: ${({ theme }) => theme.colors.cross.silverFox};
    }
  }
`;
